import { render, staticRenderFns } from "./UsageDetails.vue?vue&type=template&id=2a9bbc22"
import script from "./UsageDetails.vue?vue&type=script&lang=js"
export * from "./UsageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports